// extracted by mini-css-extract-plugin
export var active = "_9v-7";
export var container = "_9v-0";
export var evenWidth = "_9v-4";
export var large = "_9v-5";
export var outlet = "_9v-8";
export var slide = "_9v-2";
export var small = "_9v-6";
export var tab = "_9v-3";
export var tabs = "_9v-1";